// extracted by mini-css-extract-plugin
export var actionButton = "_9d-1";
export var actionButtons = "_9d-2";
export var actions = "_9d-0";
export var aiUnread = "_9d-10";
export var alignCenter = "_9d-h";
export var backWrapper = "_9d-3";
export var cellContainer = "_9d-4";
export var checkboxContainer = "_9d-5";
export var contentContainer = "_9d-6";
export var contentHeader = "_9d-8";
export var conversationsTableWrapper = "_9d-s";
export var draftReplyBadgeContainer = "_9d-m";
export var dropdownItem = "_9d-b";
export var dropdownItemsContainer = "_9d-a";
export var dropdownTitle = "_9d-c";
export var errorIcon = "_9d-7";
export var filter = "_9d-d";
export var gray = "_9d-i";
export var headerActionButtons = "_9d-e";
export var headerCheckboxContainer = "_9d-f";
export var icon = "_9d-j";
export var menuContainer = "_9d-k";
export var noMoreTicketsIcon = "_9d-12";
export var noMoreTicketsSubText = "_9d-13";
export var oneLine = "_9d-l";
export var optionsButton = "_9d-n";
export var plus = "_9d-o";
export var portalButtonsWrapper = "_9d-g";
export var red = "_9d-p";
export var scrolledTop = "_9d-9";
export var search = "_9d-q";
export var selectedConversationsCount = "_9d-r";
export var spinner = "_9d-t";
export var strong = "_9d-u";
export var summaryCell = "_9d-v";
export var tableContainer = "_9d-11";
export var tagContainer = "_9d-w";
export var threeDots = "_9d-x";
export var twoLines = "_9d-y";
export var unread = "_9d-z";